import { IonButton } from '@ionic/react';
import { useBreakpoints } from '../theme/useBreakpoints';
import { ArrowRightIcon } from '../theme/Icons';

export const ManageButton: React.FC<{ onManage: () => void }> = ({ onManage }) => {
    const { isAboveBreakpoint } = useBreakpoints();
    return (
        <IonButton
            fill="clear"
            color="primary"
            data-id="community-management-button"
            onClick={onManage}
        >
            {isAboveBreakpoint('sm') ? 'Manage Community' : 'Manage'}&nbsp;<ArrowRightIcon />
        </IonButton>
    );
};
